import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface TipoSiniestro {
  id?: number; // opcional en creación
  nombre: string;
  estado?: number; // opcional en creación
  fechaCreacion?: string; // lo devuelve el backend
  fechaModificacion?: string | null; // lo devuelve el backend
}

@Injectable({
  providedIn: "root",
})
export class TipoSiniestroService {
  private apiUrl = `${environment.apiUrl}/api/tipo-siniestro`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getTipos(): Observable<TipoSiniestro[]> {
    return this.http
      .get<TipoSiniestro[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getAllTipoSiniestroActivos(): Observable<TipoSiniestro[]> {
    return this.http
      .get<TipoSiniestro[]>(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getTipoById(id: string | number): Observable<TipoSiniestro> {
    return this.http
      .get<TipoSiniestro>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createTipo(payload: TipoSiniestro): Observable<TipoSiniestro> {
    return this.http
      .post<TipoSiniestro>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateTipo(id: string | number, payload: TipoSiniestro): Observable<TipoSiniestro> {
    return this.http
      .put<TipoSiniestro>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteTipo(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
